import { Table } from '@mantine/core';

import { serviceTypes } from '../../types';

import { BodyRow } from './BodyRow';

import { Departments } from '@/types';

type ServicesTableProps = {
  department: Departments;
  services: serviceTypes.Service[];
};

export const ServicesTable = ({ department, services }: ServicesTableProps) => {
  return (
    <Table stickyHeader striped highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Название</Table.Th>
          <Table.Th>Ключ</Table.Th>
          <Table.Th>Действия</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {services?.map((service) => (
          <BodyRow key={service._id} department={department} service={service} />
        ))}
      </Table.Tbody>
    </Table>
  );
};
